module.exports = __webpack_public_path__ + "img/bc1_home.ef4bf598.png";